import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import DesignGrid from './DesignGrid';

const SectionContainer = styled(Box)(({ theme }) => ({
  background: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
  border: '1px solid rgba(0, 0, 0, 0.04)',
  padding: '24px 16px 32px 16px',
  [theme.breakpoints.up('sm')]: {
    borderRadius: '14px',
    padding: '32px 24px 40px 24px',
    boxShadow: '0 3px 18px rgba(0, 0, 0, 0.06)'
  },
  [theme.breakpoints.up('md')]: {
    borderRadius: '16px',
    padding: '40px 32px 48px 32px',
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)'
  }
}));

const SectionHeader = styled(Stack)(({ theme }) => ({
  gap: '8px',
  alignItems: 'center',
  textAlign: 'center',
  marginBottom: '24px',
  [theme.breakpoints.up('sm')]: {
    gap: '10px',
    marginBottom: '32px'
  },
  [theme.breakpoints.up('md')]: {
    gap: '12px',
    marginBottom: '40px'
  }
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
  fontSize: '20px',
  fontWeight: 700,
  color: '#1a1a2e',
  letterSpacing: '-0.3px',
  [theme.breakpoints.up('sm')]: {
    fontSize: '24px',
    letterSpacing: '-0.4px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '28px',
    letterSpacing: '-0.5px'
  }
}));

const SectionDescription = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
  fontSize: '13px',
  fontWeight: 400,
  color: '#64748b',
  maxWidth: '100%',
  lineHeight: 1.5,
  padding: '0 8px',
  [theme.breakpoints.up('sm')]: {
    fontSize: '14px',
    maxWidth: '480px',
    lineHeight: 1.55,
    padding: 0
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '15px',
    maxWidth: '560px',
    lineHeight: 1.6
  }
}));

const SelectDesignSection = ({ designs, onDesignSelect, accountInfo }) => {
  return (
    <SectionContainer>
      <SectionHeader>
        <SectionTitle>Select Design</SectionTitle>
        <SectionDescription>
          Choose a design template to get started with your marketing material.
        </SectionDescription>
      </SectionHeader>
      <DesignGrid
        designs={designs}
        onDesignSelect={onDesignSelect}
        accountInfo={accountInfo}
      />
    </SectionContainer>
  );
};

export default SelectDesignSection;